import React from 'react'
import "./Common_section_heading.css"

function Common_section_heading({ title, subTitle }) {
    return (
        <>
            <section className='Common_section_heading'>
                <h2 className="section_title">{title}</h2>
                <p className="section_subtitle">
                    {subTitle}
                </p>
            </section>
        </>
    )
}

export default Common_section_heading